import React, { useContext, useState } from 'react';
import './ReportIssueForm.css';
import { ReactComponent as CloseForm } from '../images/close-message.svg';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import ReportIssueError from './ReportIssueError';
import { useMutation } from '@tanstack/react-query';
import {
  initialValues,
  validationSchema,
} from '../config/createIssueFormConfig';
import ClipLoader from 'react-spinners/ClipLoader';
import { AppInfoContext } from '../../../../App';

function ReportIssueForm(props) {
  const { setAppInformation } = useContext(AppInfoContext);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [issueCode, setIssueCode] = useState(null);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorCode, setErrorCode] = useState(null);
  const [submittingForm, setSubmittingForm] = useState(false);
  const token = localStorage.getItem('token');

  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const onSubmit = (values, onSubmitProps) => {
    setSubmittingForm(true);

    if (values.image === '')
      return reportIssueMutate({ ...values, image: null });

    const formData = new FormData();
    formData.append('image', values.image);

    const submitData = {
      values,
      image: formData,
    };

    uploadIssueImageMutate(submitData);
  };

  const { mutate: reportIssueMutate } = useMutation({
    mutationFn: (issueData) =>
      fetch(`${apiUrl}/issues`, {
        method: 'POST',
        body: JSON.stringify({
          ...issueData,
          address: issueData.address === '' ? null : issueData.address,
          geom: {
            type: 'Point',
            coordinates: [props.issueCoordinates.x, props.issueCoordinates.y],
          },
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => res.json()),

    onSuccess: (response) => {
      if (
        (response.statusCode < 300 && response.statusCode > 199) ||
        !response.statusCode
      ) {
        setFormSubmitted(true);
        setIssueCode(response.code);
        setSubmittingForm(false);
        return;
      }
      setErrorMessage(true);
      setErrorCode(response.statusCode);
    },
    onError: (error) => {
      console.log('error', error);
      setErrorMessage(true);
      setSubmittingForm(false);
    },
  });
  const { mutate: uploadIssueImageMutate } = useMutation({
    mutationFn: (issueData) =>
      fetch(`${apiUrl}/upload/issue`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: issueData.image,
      }).then((res) => res.json()),

    onSuccess: (response, issueData) => {
      reportIssueMutate({ ...issueData.values, image: response.image });
    },
    onError: () => {
      console.log('error');
    },
  });

  const closeForm = () => {
    setAppInformation((prevValue) => {
      return {
        ...prevValue,
        citizenReport: {
          currentStep: 0,
          issueCoordinates: { x: null, y: null },
        },
      };
    });
  };

  return (
    <div className="report-issue-form">
      <div className="form-bg-shadow" onClick={closeForm}></div>
      <div
        className={
          formSubmitted || errorMessage
            ? 'form-container p-message'
            : 'form-container'
        }
        style={{
          width: errorMessage ? '520px' : !formSubmitted ? '' : '520px',
          height: (formSubmitted || errorMessage) && '230px',
        }}
      >
        <div className="form-header">
          <div className="form-header-title">Prijava kvara</div>
          <button
            style={{ fontWeight: 'bolder' }}
            className="form-close-button"
            onClick={closeForm}
          >
            <CloseForm style={{ height: '10px' }} />
          </button>
        </div>

        {!formSubmitted && !errorMessage && (
          <div className="form">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              validateOnChange={false}
            >
              {(formik) => {
                return (
                  <Form className="form-body-container">
                    <div className="form-body">
                      <div className="guest-information">
                        <div className="form-control form-checkbox">
                          <Field
                            type="checkbox"
                            id="anonymous"
                            name="anonymous"
                            className="checkbox-input"
                            onClick={() => {
                              if (!formik.values.anonymous) {
                                formik.setFieldValue('guestName', null);
                                formik.setFieldValue('guestEmail', null);
                                formik.setFieldValue('guestNumber', null);
                              }
                            }}
                          />
                          <label htmlFor="anonymous">Anonimna prijava</label>
                        </div>
                        {!formik.values.anonymous && (
                          <>
                            <div className="form-control">
                              <label
                                htmlFor="guestName"
                                className="field-title"
                              >
                                Ime i prezime
                              </label>
                              <Field
                                type="text"
                                id="guestName"
                                name="guestName"
                                className="form-field"
                                maxLength="30"
                              />
                              <ErrorMessage
                                name="guestName"
                                component={ReportIssueError}
                              />
                            </div>
                            <div className="form-control">
                              <label htmlFor="email" className="field-title">
                                Email
                              </label>
                              <Field
                                type="guestEmail"
                                id="guestEmail"
                                name="guestEmail"
                                className="form-field"
                                maxLength="40"
                              />
                              <ErrorMessage
                                name="guestEmail"
                                component={ReportIssueError}
                              />
                            </div>
                            <div className="form-control">
                              <label
                                htmlFor="guestNumber"
                                className="field-title"
                              >
                                Broj telefona
                              </label>
                              <Field
                                type="text"
                                id="guestNumber"
                                name="guestNumber"
                                className="form-field"
                                maxLength="15"
                              />
                              <ErrorMessage
                                name="guestNumber"
                                component={ReportIssueError}
                              />
                            </div>
                          </>
                        )}
                      </div>

                      <div className="issue-details">
                        <div className="form-control">
                          <label htmlFor="address" className="field-title">
                            Adresa kvara
                          </label>
                          <Field
                            type="text"
                            id="address"
                            name="address"
                            className="form-field"
                            maxLength="40"
                          />
                          <ErrorMessage
                            name="address"
                            component={ReportIssueError}
                          />
                        </div>

                        <div className="form-control">
                          <label htmlFor="description" className="field-title">
                            Opis kvara
                          </label>
                          <Field
                            as="textarea"
                            id="description"
                            name="description"
                            className="form-field form-textbox"
                            maxLength="180"
                          />
                          <ErrorMessage
                            name="description"
                            component={ReportIssueError}
                          />
                        </div>

                        <div className="form-control">
                          <label
                            htmlFor="image"
                            className="field-title"
                            id="image"
                          >
                            Fotografija kvara
                          </label>
                          <input
                            type="file"
                            id="image"
                            name="image"
                            onChange={(e) => {
                              formik.setFieldValue('image', e.target.files[0]);
                            }}
                          />
                          <ErrorMessage
                            name="image"
                            component={ReportIssueError}
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="form-button"
                      disabled={submittingForm}
                    >
                      {submittingForm ? (
                        <ClipLoader
                          color={'white'}
                          loading={submittingForm}
                          size={20}
                          data-testid="loader"
                        />
                      ) : (
                        'Prijavi kvar'
                      )}
                    </button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        )}

        {formSubmitted && (
          <div className="submitted-form">
            <div className="submitted-form-text">
              Hvala na prijavi kvara! Sačuvajte kod <b>{issueCode}</b> kako
              biste provjerili status prijave.
            </div>

            <button
              className="form-button close-code-message"
              onClick={closeForm}
            >
              Zatvori
            </button>
          </div>
        )}

        {errorMessage && (
          <div className="submitted-form">
            <div className="submitted-form-text">
              {errorCode === 429
                ? 'Iskoristili ste maksimalan broj prijava kvarova za danas.'
                : 'Trenutno nije moguće izvršiti prijavu kvara. Probajte kasnije.'}
            </div>

            <button
              className="form-button close-code-message"
              onClick={closeForm}
            >
              Zatvori
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ReportIssueForm;
